// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1IARK","header":"MergedInvoice_header__2N2N5"};